(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2521],{

/***/ 26301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(68921);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FallbackImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59108);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50937);
/* harmony import */ var _fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71415);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* eslint-disable @next/next/no-img-element */ 



function FallbackImage(param) {
    let { src , alt ="image" , onError , style , fill , width , height , ...props } = param;
    const isValidSrc = src && (src.startsWith("/") || src.startsWith("http://") || src.startsWith("https://"));
    if (!isValidSrc) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        ...props,
        style: style,
        src: src,
        alt: alt,
        title: alt,
        fill: fill,
        width: width,
        height: height,
        className: (_fallbackImage_module_scss__WEBPACK_IMPORTED_MODULE_3___default().root),
        onError: (e)=>{
            e.target.style.visibility = "hidden";
            onError === null || onError === void 0 ? void 0 : onError(e);
        }
    });
}


/***/ }),

/***/ 12651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23934);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51834);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34741);
/* harmony import */ var constants_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30300);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85286);





function SEO(param) {
    let { title , description =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_DESCRIPTION */ .KM , image =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_IMAGE */ .T5 , keywords =constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_KEYWORDS */ .cU  } = param;
    const { settings  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_4__/* .useSettings */ .r)();
    const projectTitle = (settings === null || settings === void 0 ? void 0 : settings.title) || constants_config__WEBPACK_IMPORTED_MODULE_3__/* .META_TITLE */ .k5;
    const currentURL = constants_constants__WEBPACK_IMPORTED_MODULE_2__/* .WEBSITE_URL */ .o6;
    const siteTitle = title ? title + " | " + projectTitle : projectTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "Website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                property: "og:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "author",
                property: "og:author",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: currentURL
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                href: (settings === null || settings === void 0 ? void 0 : settings.favicon) || "/favicon.png"
            })
        ]
    });
}


/***/ }),

/***/ 68921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ About; }
});

// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23934);
// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(59108);
// EXTERNAL MODULE: ./components/seo.tsx
var seo = __webpack_require__(12651);
// EXTERNAL MODULE: ./containers/aboutUs/aboutUs.module.scss
var aboutUs_module = __webpack_require__(58618);
var aboutUs_module_default = /*#__PURE__*/__webpack_require__.n(aboutUs_module);
// EXTERNAL MODULE: ./components/fallbackImage/fallbackImage.tsx
var fallbackImage = __webpack_require__(80869);
;// CONCATENATED MODULE: ./containers/aboutUs/aboutUs.tsx
/* eslint-disable @next/next/no-img-element */ 



function AboutUs(param) {
    let { data  } = param;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (aboutUs_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (aboutUs_module_default()).header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: (aboutUs_module_default()).title,
                            children: data === null || data === void 0 ? void 0 : (ref = data.translation) === null || ref === void 0 ? void 0 : ref.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (aboutUs_module_default()).text
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (aboutUs_module_default()).hero,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
                        fill: true,
                        src: data === null || data === void 0 ? void 0 : data.img,
                        alt: data === null || data === void 0 ? void 0 : (ref1 = data.translation) === null || ref1 === void 0 ? void 0 : ref1.title,
                        sizes: "(max-width: 768px) 600px, 1072px"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: (aboutUs_module_default()).content,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (aboutUs_module_default()).text,
                        dangerouslySetInnerHTML: {
                            __html: (data === null || data === void 0 ? void 0 : (ref2 = data.translation) === null || ref2 === void 0 ? void 0 : ref2.description) || ""
                        }
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./containers/appSection/appSection.module.scss
var appSection_module = __webpack_require__(83189);
var appSection_module_default = /*#__PURE__*/__webpack_require__.n(appSection_module);
;// CONCATENATED MODULE: ./containers/appSection/appSection.tsx
/* eslint-disable @next/next/no-img-element */ 



function AppSection(param) {
    let { data =[]  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: data.map((item)=>{
            var ref, ref1, ref2, ref3, ref4;
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                className: (appSection_module_default()).container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (appSection_module_default()).wrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (appSection_module_default()).imgWrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fallbackImage/* default */.Z, {
                                    fill: true,
                                    src: item.img,
                                    alt: (ref = item.translation) === null || ref === void 0 ? void 0 : ref.title,
                                    sizes: "(max-width: 768px) 600px, 1072px"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (appSection_module_default()).content,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: (appSection_module_default()).title,
                                        children: (ref1 = item.translation) === null || ref1 === void 0 ? void 0 : ref1.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: (appSection_module_default()).text,
                                        dangerouslySetInnerHTML: {
                                            __html: ((ref2 = item.translation) === null || ref2 === void 0 ? void 0 : ref2.description) || ""
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (appSection_module_default()).flex,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: (ref3 = item.buttons) === null || ref3 === void 0 ? void 0 : ref3.app_store_button_link,
                                                className: (appSection_module_default()).item,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/app-store.webp",
                                                    alt: "App store"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: (ref4 = item.buttons) === null || ref4 === void 0 ? void 0 : ref4.google_play_button_link,
                                                className: (appSection_module_default()).item,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: "/images/google-play.webp",
                                                    alt: "Google play"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }, item.id);
        })
    });
}

// EXTERNAL MODULE: ../../../extlink-store/web/node_modules/.pnpm/react-query@3.39.3_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-query/es/index.js
var es = __webpack_require__(65084);
// EXTERNAL MODULE: ./services/page.ts
var page = __webpack_require__(67122);
// EXTERNAL MODULE: ./hooks/useLocale.tsx
var useLocale = __webpack_require__(72526);
;// CONCATENATED MODULE: ./pages/about.tsx








var __N_SSG = true;
function About(param) {
    let {} = param;
    const { t , locale  } = (0,useLocale/* default */.Z)();
    const { data  } = (0,es.useQuery)([
        "sections",
        locale
    ], ()=>page/* default.getAboutSections */.Z.getAboutSections(), {
        select: (data)=>{
            if (data.data.length > 1) {
                return {
                    about: data.data.find((item)=>item.type === "about"),
                    sections: data.data.filter((item)=>item.type !== "about")
                };
            }
            return {
                about: data.data[0],
                sections: []
            };
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                title: t("about")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutUs, {
                data: data === null || data === void 0 ? void 0 : data.about
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppSection, {
                data: data === null || data === void 0 ? void 0 : data.sections
            })
        ]
    });
}


/***/ }),

/***/ 67122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36155);

const pageService = {
    getDeliverPage: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/pages/delivery", {
            params
        }),
    getAboutPage: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/pages/about", {
            params
        }),
    getAboutSections: ()=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/pages/paginate?page=1&perPage=10&type=all_about"),
    getLandingPage: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/landing-pages/welcome", {
            params
        }),
    getStatistics: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/stat", {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (pageService);


/***/ }),

/***/ 50937:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"fallbackImage_root__7qEqB"};

/***/ }),

/***/ 58618:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"aboutUs_container__UTyhR","header":"aboutUs_header__TO_AD","title":"aboutUs_title__cxrj_","muted":"aboutUs_muted__L7aWB","text":"aboutUs_text__FuHkD","hero":"aboutUs_hero__o7F5a","content":"aboutUs_content__9kP75"};

/***/ }),

/***/ 83189:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"appSection_container__Qf8WQ","wrapper":"appSection_wrapper__S4jnG","content":"appSection_content__b_kjv","title":"appSection_title__Q6WqS","text":"appSection_text__f8VQL","bold":"appSection_bold__4JQCG","flex":"appSection_flex__ho0Vq","item":"appSection_item__bMqlX","imgWrapper":"appSection_imgWrapper__3gS_K"};

/***/ }),

/***/ 51834:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(58761)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(26301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);